import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const SECTIONS = [
  {
    title: "1. About this website",
    body: "This website is operated by Vanguard Prep School Limited (the School) to provide information about the School and to collect expressions of interest in enrolment for the 2027 foundation intake. By using this website you accept these terms of use. If you do not accept them, please do not use the website.",
  },
  {
    title: "2. Information only",
    body: "The content on this website is general information about the School and its planned opening. It does not constitute an offer of enrolment, and submitting an expression of interest does not guarantee a place at the School. Programme, date and other details may change before opening.",
  },
  {
    title: "3. Your use of the website",
    body: "You agree to use this website lawfully and honestly, and to provide accurate information in the expression of interest form. You must not misuse the website, attempt to interfere with its operation, or submit information belonging to another person without their knowledge.",
  },
  {
    title: "4. Intellectual property",
    body: "The text, design, logo and imagery on this website belong to the School or its licensors. You may view and share links to the website, but you may not copy or reuse its content for any other purpose without the School's written permission.",
  },
  {
    title: "5. Privacy",
    body: "Personal information submitted through this website is handled as described in our Privacy Policy, available from the link in the footer of this website.",
  },
  {
    title: "6. Liability",
    body: "The School takes care to keep this website accurate and available, but provides it as is and does not guarantee it will be error-free or uninterrupted. To the extent permitted by law, the School is not liable for any loss arising from use of, or inability to use, this website.",
  },
  {
    title: "7. Changes to these terms",
    body: "The School may update these terms from time to time. The version published on this page at the time of your visit applies to your use of the website.",
  },
  {
    title: "8. Governing law",
    body: "These terms are governed by the laws of New Zealand.",
  },
];

export default function TermsOfUse() {
  return (
    <main className="relative overflow-hidden pb-24 pt-16 lg:pt-24">
      <div className="pointer-events-none absolute -top-24 right-1/4 h-[24rem] w-[24rem] rounded-full bg-gold/10 blur-[110px]" />

      <div className="relative z-10 mx-auto w-full max-w-3xl px-4 sm:px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <Link
            to="/"
            data-testid="terms-back-link"
            className="mb-8 flex w-fit items-center gap-2 font-mono text-[11px] tracking-[0.2em] text-slate-500 transition-colors duration-300 hover:text-gold"
          >
            <ArrowLeft className="h-3.5 w-3.5" /> BACK TO SITE
          </Link>

          <p className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-gold">VPS</p>
          <h1 data-testid="terms-title" className="font-serif text-3xl font-bold tracking-tight text-navy sm:text-5xl">
            Terms of Use
          </h1>

          <div className="mt-10 flex flex-col gap-8 rounded-3xl border border-slate-200 bg-white p-8 shadow-xl sm:p-12">
            {SECTIONS.map((s) => (
              <section key={s.title}>
                <h2 className="font-serif text-lg font-semibold text-navy">{s.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.body}</p>
              </section>
            ))}
          </div>
        </motion.div>
      </div>
    </main>
  );
}
